import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Sort" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SortContainer = _resolveComponent("SortContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: "SortButton",
      ref: "sortButton"
    }, _cache[1] || (_cache[1] = [
      _createElementVNode("i", { class: "lnr-sort-amount-asc SortButtonIconDesktop" }, null, -1 /* CACHED */),
      _createTextVNode(" Sort ", -1 /* CACHED */)
    ]), 512 /* NEED_PATCH */),
    _createVNode(_component_SortContainer)
  ]))
}